<template>
  <div class="card-box">
    <CardTitle :title="title" :subtitle="subtitle" :noBg="noBg"/>
    <div class="card-box__content" :style="contentStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CardTitle from './cardTitle.vue'

export default {
  name: 'CardBox',
  components: {
    CardTitle
  },
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    contentStyle: {
      type: Object,
      default: () => ({})
    },
    noBg: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__content {
    flex: 1;
    height: calc(100% - 38px);
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
</style>
